module.exports = __webpack_public_path__ + "img/fatigue.dc8782db.svg";